import React from "react";
import { Skeleton } from "@mui/material";

const ProductSkeleton = () => {
    return (
        <div className="flex flex-col items-center gap-2  w-full bg-white">
            <div className="w-3/4 flex flex-col gap-2 mt-3">
                <div className="w-full">
                    <Skeleton variant="rounded" height={130} />
                </div>
                <div className="text-xs w-full">
                    <Skeleton />{" "}
                    <div className="w-1/2">
                        <Skeleton />
                    </div>
                </div>
                <div className="text-xxs w-full mb-3">
                    <div className="text-xxs w-1/4">
                        <Skeleton />
                    </div>
                    <div className="text-xxs w-4/5">
                        <Skeleton />
                    </div>
                </div>
            </div>
            <div className="w-3/4 flex justify-start mb-3">
                <Skeleton variant="rounded" width={70} height={22} />
            </div>
        </div>
    );
};

export default ProductSkeleton;
